import { ScreenerFilter } from '@api/api/screener';

export const insightsAssetFilter: ScreenerFilter = {
  key: 'explore_assets',
  name: 'Assets',
  visible: true,
  searchable: true,
  category: 'Universe',
  locked: true,
  config: {
    multiselect: false,
    name: 'Assets',
    options: [],
  },
};
